import Actions                     from 'Redux/Actions';
import { EventCategoryRepository } from 'Domain/Repositories';
import { ofType }                  from 'redux-observable';
import { from }                    from 'rxjs';
import { mergeMap }                from 'rxjs/operators';
import { TEpic }                   from 'Redux/Config';

export const findEventCategoriesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventCategoriesRequest.type),
    mergeMap(action => from(
      EventCategoryRepository.findAll(action.payload)
        .then(({ eventCategories, meta }) => Actions.findEventCategoriesSuccess({ eventCategories, maxCount: meta?.count }))
        .catch((error: Error) => Actions.findEventCategoriesFailure({ error })),
    )),
  );
};
